module.exports = __webpack_public_path__ + "static/img/aca.eddf607a.png";